'use strict';

angular.module('transport.configuration.transportTimeslotEdit',
    [
        'ccaSignUpType.services.ccaSignUpTypeService',
        'transport.services.transportTimeSlotsService',
        'transport.services.transportDirectionsService',
        'shared.directives.sbCheckBox',
        'shared.components.sbModalHeader',
        'shared.components.sbOnOffSwitch',
        'shared.services.simpleAlertService',
        'shared.services.toastService',
    ])
    .component('transportTimeslotEdit',
        {
            bindings: {
                resolve: '<',
                modalInstance: '<',
            },
            templateUrl: '/Scripts/app/transport/configuration/timeSlots/transport-timeslot-edit.template.html',
            controller: [
                '$timeout',
                '$uibModal',
                'cachedLookupService',
                'ccaSignUpTypeService',
                'transportTimeSlotsService',
                'transportDirectionsService',
                'simpleAlertService',
                'toastService',
                function transportTimeslotAddController($timeout,
                                                        $uibModal,
                                                        cachedLookupService,
                                                        ccaSignUpTypeService,
                                                        transportTimeSlotsService,
                                                        transportDirectionsService,
                                                        simpleAlertService,
                                                        toastService)
                {
                    this.isSubmitted = false;
                    this.anyChanges = false;
                    this.isArchiveOptionAvailable = false;
                    this.transportTimeSlotArchivingInfo = {};
                    this.numberOfTimetablesWhereUsed = 0;

                    this.getOptionByIndex = function (index)
                    {
                        return { id: index, label: ('0' + index).slice(-2) };
                    }

                    this.populateOptions = function (index)
                    {
                        var i = 0;
                        var options = [];

                        for (i = 0; i < index; i++)
                        {
                            // populate options, padding with leading zero.
                            options.push(this.getOptionByIndex(i));
                        }
                        return options;
                    }

                    this.onStartChanged = function () {
                        if (this.transportTimeSlotArchivingInfo.earliestRouteStartHour == undefined ||
                            this.transportTimeSlotArchivingInfo.earliestRouteStartMinute == undefined) {
                            return;
                        }

                        var hour = this.timeSlot.startHour.id;
                        var minute = this.timeSlot.startMinute.id;
                        var earliestHour = this.transportTimeSlotArchivingInfo.earliestRouteStartHour.id;
                        var earliestMinute = this.transportTimeSlotArchivingInfo.earliestRouteStartMinute.id;

                        if (hour > earliestHour) {
                            this.timeSlot.startHour = this.getOptionByIndex(earliestHour);
                            this.timeSlot.startMinute = this.getOptionByIndex(earliestMinute);
                            this.departureTimeSetToEarliest(earliestHour, earliestMinute);
                            return;
                        }

                        if (hour === earliestHour && minute > earliestMinute) {
                            this.timeSlot.startMinute = this.getOptionByIndex(earliestMinute);
                            this.departureTimeSetToEarliest(earliestHour, earliestMinute);
                            return;
                        }
                    };

                    this.departureTimeSetToEarliest = function (earliestHour, earliestMinute) {
                        toastService.warningWithParams('SB_Transport_Time_Slot_Start_Time_Set_To_Earliest_Route_Start_Time', {
                            routeStartTime: ('0' + earliestHour).slice(-2) + ':' + ('0' + earliestMinute).slice(-2)
                        });
                    }

                    this.hourIsDisabled = function (hour)
                    {
                        return hour > -1 && (hour < this.minHour || hour > this.maxHour);
                    }

                    this.minuteIsDisabled = function (minute)
                    {
                        return minute > -1 && (minute < this.minMinute || minute > this.maxMinute);
                    }

                    var resetSubmitButtons = function ()
                    {
                        $timeout(function ()
                        {
                            this.isSubmitted = false;
                        }.bind(this), 200);

                    }.bind(this);

                    this.transportDirections = null;

                    transportDirectionsService.getTransportDirections().then(function (data)
                    {
                        this.transportDirections = data;

                    }.bind(this), function (error)
                    {
                        simpleAlertService.errorAlert(error);
                    }.bind(this));

                    this.$onChanges = function (changes)
                    {
                        if (changes.resolve)
                        {
                            var params = this.resolve.params;
                            this.timeSlot = params.timeSlot;

                            transportTimeSlotsService.getTransportTimeSlotArchivingInfo(this.timeSlot.id)
                                .then(function (responseData)
                                {
                                    this.transportTimeSlotArchivingInfo = responseData;

                                    this.transportTimeSlotArchivingInfo.timetableCalendarsWhereUsed.forEach(function (calendar)
                                    {
                                        this.numberOfTimetablesWhereUsed += calendar.timetables.length;
                                    }.bind(this));

                                    cachedLookupService.isOrganisationSuperAdminOrTransportAdvancedAdmin()
                                        .then(function (response)
                                        {
                                            this.isArchiveOptionAvailable = response == 1;
                                        }.bind(this))
                                        .catch(function (responseData)
                                        {
                                            var message = {};

                                            if (responseData && responseData.data && responseData.data.Message)
                                            {
                                                message = { message: responseData.data.Message };
                                            }

                                            alertAndResetOkButton(message);
                                        }.bind(this));

                                }.bind(this))
                                .catch(function (responseData)
                                {
                                    var message = {};

                                    if (responseData && responseData.data && responseData.data.Message)
                                    {
                                        message = { message: responseData.data.Message };
                                    }

                                    alertAndResetOkButton(message);
                                }.bind(this))
                        }
                    }

                    this.$onInit = function ()
                    {
                        this.minutes = this.populateOptions(60);
                        this.hours = this.populateOptions(24);
                        this.loadCcaSignUpTypesForTransport();

                        //configure the drop down control
                        this.dropdownSettings =
                            {
                                showUncheckAll: false,
                                showCheckAll: false,
                                checkBoxes: true,
                                smartButtonMaxItems: 3,
                                smartButtonTextConverter: function (itemText) { return itemText; }
                            };

                        this.dropdownEventEdit =
                            {
                                onSelectionChanged: function ()
                                {
                                }.bind(this)
                            }

                    }.bind(this);

                    this.loadCcaSignUpTypesForTransport = function ()
                    {
                        ccaSignUpTypeService.getCcaSignUpTypesAvailableForTransport()
                            .then(function (data)
                            {
                                if (!Array.isArray(data))
                                {
                                    simpleAlertService.errorAlert();
                                    return;
                                }

                                this.ccaSignUpTypes = data;

                            }.bind(this), function (error)
                            {
                                simpleAlertService.errorAlert(error);
                            }.bind(this));

                    }.bind(this);

                    this.cancel = function ()
                    {
                        this.modalInstance.dismiss('cancel');
                    };

                    var alertAndResetOkButton = function (message)
                    {
                        simpleAlertService.errorAlert(message);
                        resetSubmitButtons();
                    };

                    var closeModal = function (responseDto)
                    {
                        this.modalInstance.close(responseDto);
                    }.bind(this);

                    this.editTimeSlot = function ()
                    {
                        transportTimeSlotsService.updateTransportTimeSlot(this.timeSlot)
                        .then(function (data)
                        {
                            simpleAlertService.simpleAlert(
                                {
                                    title: 'SB_Saved',
                                    message: 'SB_Transport_Time_Slot_Changed',
                                    staticBackdrop: true
                                });
                            closeModal();
                        }.bind(this), function (error)
                        {
                            this.isSubmitted = false;
                            alertAndResetOkButton({ message: error.data.Message });
                        }.bind(this));
                    }.bind(this);

                    this.archiveTransportTimeSlot = function ()
                    {
                        var transportItemNameToArchive = this.timeSlot.name;

                        var confirmArchiveModalInstance = $uibModal.open(
                            {
                                animation: true,
                                component: 'transportConfirmArchiving',
                                size: 'md',
                                backdrop: 'static',
                                resolve:
                                {
                                    params: function ()
                                    {
                                        return { transportItemNameToArchive: transportItemNameToArchive };
                                    }
                                }
                            });

                        confirmArchiveModalInstance.result
                            .then(
                                () => {
                                    transportTimeSlotsService.archiveTimeSlot(this.timeSlot)
                                        .then(function (responseData)
                                        {
                                            if (responseData && responseData.isArchiveSuccess)
                                            {
                                                simpleAlertService.simpleAlert({
                                                    title: 'SB_Transport_TimeSlot_Archived',
                                                    message: 'SB_Transport_TimeSlot_Archived',
                                                    staticBackdrop: true
                                                });

                                                closeModal();
                                            }
                                            else if (responseData && !responseData.isArchiveSuccess)
                                            {
                                                simpleAlertService.simpleAlert({
                                                    title: 'SB_Error',
                                                    message: 'SB_Transport_Archive_Operation_Failed',
                                                    staticBackdrop: true
                                                });

                                                closeModal();
                                            }
                                            else
                                            {
                                                alertAndResetOkButton();
                                            }
                                        })
                                        .catch(function (responseData)
                                        {
                                            var message = {};

                                            if (responseData && responseData.data && responseData.data.Message)
                                            {
                                                message = { message: responseData.data.Message };
                                            }

                                            alertAndResetOkButton(message);
                                        });
                                    resetSubmitButtons();
                                },
                                () => resetSubmitButtons()
                            );
                    }.bind(this);
                }
            ]
        });
